import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Row,
  Col,
  notification,
  Flex,
  Typography,
  Dropdown,
  TreeSelect
} from "antd";
import {
  ExpandOutlined,
  ShrinkOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  ExportOutlined
} from "@ant-design/icons";
import CommonAttributeList from "../common/CommonAttributeList";
import VariationDetails from "./VariationDetails";
import VariantProductList from "./VariantProductList"
import UploadButton from "../common/UploadButton";
import globalData from "../../config/global_data";
import ErrorNotification from "../common/ErrorNotification";
import common_api from "../../config/common_api";
import apiService from "./Api";
import StatusBadge from "../common/StatusBadge";
import ProductDetails from "../common/ProductDetails";
import { triggerNotification } from "../common/notify";
import { useAuth } from "../UserAuth/AuthContext";

const { Text } = Typography;
const ButtonItems = [
  {
    label: 'Save as Draft',
    key: 'saveDraft',
  },
  {
    label: 'Save & Reload',
    key: 'saveReload',
  },
];

const VariantDrawer = ({ visible, onClose, selected_prod_data, setisloader, onProductCreate, globalList, setGlobalList }) => {
  const [form] = Form.useForm();
  const [bundleTitle, setBundleTitle] = useState("New Variant Product");
  const [data, setData] = useState(selected_prod_data);
  const [treeData, setTreeData] = useState(null)
  const [stores, setStoreOptions] = useState([]);
  const [imageObj, setImageObj] = useState(null);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [savedimages, setSavedimgaes] = useState(null);
  const [savedattributes, setSavedattributes] = useState(null);
  const [savedVariants, setSavedVariants] = useState(null);
  const [savedVariantOptions, setSavedVariantOptions] = useState(null);
  const [alert, setAlert] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [removedValues, setRemovedValues] = useState(null);
  const { userData } = useAuth();
  const [hasAttributeError, setHasAttributeError] = useState(false);

  const handleInputChange = (name) => (e) => {
    const value = e.target.value.replace(/[^\d]/g, ''); // Only allow digits, no decimal point
    form.setFieldsValue({ [name]: value });
  };
  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    if (hasAttributeError) {
      triggerNotification({
        type: 'error',
        title: 'Attribute Error!',
        message: 'Please fix all errors before saving.'
      });
      return;
    }
    if (savedVariants?.hasDuplicateError) {
      triggerNotification({
        type: 'error',
        title: 'Duplicate Variant Value!',
        message: 'Duplicate variant values are not allowed. Please fix before saving.'
      });
      return;
    }
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };
  useEffect(() => {
    const fetchData = () => {
      if (globalData && globalData.all_cat_list && globalData.all_cat_list.length > 0) {
        let cattree = globalData.all_cat_list.filter(item => item.store_id === selected_prod_data.store_id)
        if (cattree && cattree.length > 0) {
          setTreeData(cattree[0].treedata)
        }
      }
    }

    if (selected_prod_data && visible) {
      
      fetchData()
      setData(selected_prod_data);
      // setSelectedValues(selected_prod_data.categories)
      form.setFieldsValue({
        msrpPrice: selected_prod_data.msrp,
        salePrice: selected_prod_data.sale_price,
        bc_name: selected_prod_data.bc_name,
        SAPmsrp: selected_prod_data.sapMsrp,
        SAPPrice: selected_prod_data.sapPrice,
        pname: selected_prod_data.bc_name ? selected_prod_data.bc_name : selected_prod_data.sapName,
        bcSku: selected_prod_data.bcSku,
        status: selected_prod_data.active
      });
      if (selected_prod_data && selected_prod_data.categories && selected_prod_data.categories.length > 0) {
        const categoriesStringArray = selected_prod_data.categories.map(String);
        setSelectedValues(categoriesStringArray)
      } else {
        setSelectedValues([])
      }
      setBundleTitle(selected_prod_data.bc_name || "New Variant Product");
      if (selected_prod_data && selected_prod_data.images) {
        setImageObj({ img_data: selected_prod_data.images })
      }
    }
  }, [selected_prod_data, visible]);
  const handleAlert = async (type, title, message, isopen) => {
    setAlert({ type, title, message, isopen });
    setTimeout(() => setAlert({ isopen: false }), 100);
  };
  const handleSaveAndPublish = async (values) => {
    let option_data = {}
    if (savedVariantOptions) {
      option_data = {
        id: savedVariantOptions.option_id,
        display_name: savedVariantOptions.display_name
      }
    }

    let images = [], remove_from_GCP = []
    let available_images = selected_prod_data.images

    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.thumbUrl && item.thumbUrl.startsWith('https://storage.googleapis.com/')) {
          remove_from_GCP.push(item.thumbUrl)
        }
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl ? item.thumbUrl : "",
            is_thumbnail: item.set_as_Featured,
            sort_order: item.img_order
          }
        } else {
          return {
            image_url: item.thumbUrl ? item.thumbUrl : ""
          }
        }
      })
    }
    const currentImageUrls = new Set(
      (savedimages.image_data || []).map(item => item.thumbUrl)
    );
    const deletedImages = (available_images || [])
      .filter(img => !currentImageUrls.has(img.url_standard))
      .map(img => img.id);
    let custom_fields_final = [], custom_fields_removed = [];
    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { values, attribute_key, max_size } = attr;

        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item.val) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "id": item.key,
                "name": baseKey.replace("NUM", counter),
                "value": item.val
              }
            } else if (max_size === 1) {
              itemobj = {
                "id": item.key,
                "name": baseKey,
                "value": item.val
              }
            }
            else {
              itemobj = {
                "id": item.key,
                "name": baseKey + "_" + counter,
                "value": item.val
              }
            }
            if (itemobj.id === "") {
              delete itemobj.id
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    let mapped_variant_data = [], option_array = [], new_variants = []
    if (savedVariants && savedVariants.variants) {
      await savedVariants.variants.map(item => {
        if (item.variant_image && item.variant_image.startsWith('https://storage.googleapis.com/')) {
          remove_from_GCP.push(item.variant_image)
        }
        // "cost_price": 40,
        let jsonob = {
          "price": parseFloat(item.variant_default_price ? item.variant_default_price : 0),
          "sale_price": parseFloat(item.variant_sale_price),
          "retail_price": parseFloat(item.variant_msrp),
          "inventory_level": parseInt(item.inventory_available),
          "inventory_warning_level": parseInt(item.inventory_warning_level ? item.inventory_warning_level : 0),
          "image_url": item.variant_image ? item.variant_image : ""
          // image_url:
        }
        if (item.variant_id) {
          jsonob.id = item.variant_id
        }

        if (item.options && item.options.length > 0) {

          if (!item.is_new) {
            // delete item.options[0].id
            delete option_array.option_display_name
            option_array.push(item.options[0])
          }
          if (item.is_new) {

            // jsonob.option_array
            item.options[0].label = item.options[0].label
            item.options[0].id = 0
            item.options[0].is_default = false
            // delete  item.options[0].id
            // delete  item.options[0].option_id
            jsonob.option_values = item.options
            option_array.push(item.options[0])
          }
        }
        if (item.cost_price != "") {
          jsonob.cost_price = item.cost_price
        }
        if (item.weight != "") {
          jsonob.weight = item.weight
        }
        if (item.width != "") {
          jsonob.width = item.width
        }
        if (item.height != "") {
          jsonob.height = item.height
        }
        if (item.depth != "") {
          jsonob.depth = item.depth
        }
        if (!item.is_new)
          mapped_variant_data.push(jsonob)
        if (item.is_new) {
          delete jsonob.id
          jsonob.sku = item.variant_sku
          new_variants.push(jsonob)
        }
      })

    }
    if (removedValues && removedValues.custom_fields && removedValues.custom_fields.length > 0) {
      custom_fields_removed = removedValues.custom_fields
    }
    let req_data = {
      "store": data.store,
      "store_id": selected_prod_data.store_id,
      "product_id": data.prod_id,
      "is_variant": true,
      "variants": mapped_variant_data,
      "store_id": data.store_id,
      "data": {
        "name": values.bc_name,
        "sku": data.bcSku,
        // "weight": 324,
        "price": values.msrpPrice.replace(data.currency_symbol, ""),
        "sale_price": values.salePrice.replace(data.currency_symbol, ""),
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues
      },
      option_array,
      new_variants,
      option_data,
      images_removed: deletedImages,
      remove_from_GCP,
      custom_fields_removed
    }

    setisloader(true)
    let responsedata = await common_api.update_product(req_data)

    if (responsedata) {
      if(responsedata.data){
        let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
        if (alldata) {
          await setGlobalList(alldata)
        }
      }
      triggerNotification(responsedata)
    }
    setisloader(false)
    onClose()
    // handleAlert('success', "Success", "Product Updated Successfully!", true);
  }
  const onChange = (values) => {
    setSelectedValues(values);
  };

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };
  // const handleBlur = () => {
  //   const bundleName = form.getFieldValue("bc_name");
  //   if (bundleName) {
  //     setBundleTitle(bundleName);
  //   }
  // };

  const handleBlur = () => {
    const bundleName = form.getFieldValue("bc_name");
    if (bundleName && bundleName.trim() !== "") {
      setBundleTitle(bundleName.trim());
    } else {
      // Revert to original name from selected_prod_data
      const originalName = selected_prod_data.bc_name || selected_prod_data.sapName || "New Simple Product";
      setBundleTitle(originalName);
    }
  };

  return (
    data && <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="DrawerButtonBox">
              {data.active == true && (
                <a href={selected_prod_data.bc_url ? selected_prod_data.bc_url : ""} target="_blank" style={{ marginRight: 8 }} className="ViewPage" rel="noopener noreferrer">
                  <ExportOutlined className="ViewPageIcon" style={{ fontSize: 16, color: 'rgba(0,0,0,0.88)' }} />
                </a>
              )}
              <Button
                className="ExpandDrawer"
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ marginRight: 8 }}
              >
                {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
              </Button>
              
              <ErrorNotification {...alert} />
              {userData?.data?.access === "ALL" && (
                <Dropdown.Button
                  type="primary"
                  icon={<DownOutlined />}
                  menu={{
                    items: ButtonItems,
                    onClick: handleMenuClick,
                  }}
                  trigger={['click']}
                  onClick={handleSaveAndPublishClick}
                  style={{ marginLeft: 8 }}
                >
                  Save & Publish
                </Dropdown.Button>
              )}
            </div>
          </div>

        </>
      }
    >
      <Form layout="vertical" form={form}>
        <div className="DraftBox">
          <StatusBadge
            status={form.getFieldValue("status")}
            lastEdited={data.lastUpdated} // You can make this dynamic if needed
          />
        </div>
        <ProductDetails
          productName={bundleTitle}
          sku={data.bcSku}
          msrp={data.currency_symbol + '' + data.msrp}
          salePrice={data.currency_symbol + '' + data.sale_price}
          isExpanded={isExpanded}
        />
        <Flex className="flexbox">
          <Form.Item label="Store" className="disabledstore">
            <Input placeholder="US" value={data.store} disabled />
          </Form.Item>
          <Form.Item className="w-100"
            label={
              <span>
                Product Name&nbsp;               
              </span>
            }
            name="bc_name"
            rules={[{ required: true, whitespace: true, message: "Please enter Product name" }]}
          >
            <Input placeholder="Enter a Product Name" onChange={handleBlur} value={bundleTitle} maxLength={150}/>
          </Form.Item>
        </Flex>
        <Form.Item
          label={
            <span>
              Product Categories&nbsp;              
            </span>
          }

        >

          <div>
            <TreeSelect
              className="CategoryTree"
              multiple
              allowClear
              treeData={treeData}
              value={selectedValues}
              onChange={onChange}
              placeholder="Please select categories"
              showSearch
              treeDefaultExpandAll
              treeNodeFilterProp="title"
            />
          </div>
        </Form.Item>
        <Form.Item
          label={
            <span>
              Image&nbsp;              
            </span>
          }
          name="PDPGallery"
        >
          <UploadButton
            MAX_UPLOADS="50"
            delete="true"
            replace="true"
            thumbnail="true"
            hover=""
            setSavedimgaes={setSavedimgaes}
            product_obj={imageObj}
          />
        </Form.Item>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Store MSRP&nbsp;                 
                </span>
              }
              name="msrpPrice"
              rules={[
                { required: true, message: "Please enter the Store MSRP" },
              ]}
            >
              <Input placeholder="Enter MSRP" prefix={data.currency_symbol} onChange={handleInputChange("msrpPrice")} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Store Sale Price&nbsp;                  
                </span>
              }
              name="salePrice"
               rules={[
                  { required: true, message: "Please enter the sale price" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const msrp = parseFloat(getFieldValue('msrpPrice'));
                      const sale = parseFloat(value);
                      if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Sale Price cannot be greater than MSRP');
                    },
                  }),
                ]}
            >
              <Input placeholder="Enter Store Sale Price" prefix={data.currency_symbol} onChange={handleInputChange("salePrice")} />
            </Form.Item>
          </Col>
        </Row>        

        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
          {visible && selected_prod_data && <CommonAttributeList setRemovedValues={setRemovedValues} setSavedattributes={setSavedattributes} customfielddata={selected_prod_data} setHasAttributeError={setHasAttributeError}/>}
        </div>
        {visible && <VariationDetails variantoption={selected_prod_data} setSavedVariantOptions={setSavedVariantOptions} />}
        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes VariantProductList" : ""}`}>
          {visible && selected_prod_data && <VariantProductList setSavedVariants={setSavedVariants} variantdata={selected_prod_data} form={form} />}
        </div>
      </Form>
    </Drawer>
  );
};

export default VariantDrawer;
